// @flow
export const CARD_THEME_GOEDE_ZAAKPAS = 'Goede Zaakpas'
export const CARD_THEME_GOEDE_ZAAKPAS_OUD = 'Goede Zaakpas (oud)'
export const CARD_THEME_VOOR_ELKAAR_PAS = 'Voor Elkaar pas'
export const CARD_THEME_MEEDOEN_PAS = 'Meedoen pas'
export type CardTheme = 'Goede Zaakpas' | 'Goede Zaakpas (oud)' | 'Voor Elkaar pas' | 'Meedoen pas'
export const CardThemeMapping = {
  GOEDE_ZAAKPAS: CARD_THEME_GOEDE_ZAAKPAS,
  GOEDE_ZAAKPAS_OUD: CARD_THEME_GOEDE_ZAAKPAS_OUD,
  VOOR_ELKAAR_PAS: CARD_THEME_VOOR_ELKAAR_PAS,
  MEEDOEN_PAS: CARD_THEME_MEEDOEN_PAS
}



// WEBPACK FOOTER //
// ./src/types/card-theme.js